import { render, staticRenderFns } from "./ActorRoleIndex.vue?vue&type=template&id=1a287423&"
import script from "./ActorRoleIndex.vue?vue&type=script&lang=js&"
export * from "./ActorRoleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports